export const AUTH_TOKEN_KEY = 'token';
export const AUTH_REF_TOKEN_KEY = 'refreshToken';

export enum EAuthMethod {
  COOKIE = 'COOKIE',
  TOKEN = 'TOKEN',
}
